<template>
  <div>
    <validation-observer ref="termsheetRules">
      <b-form class="position-relative">
        <b-row>
          <b-col md="12">
            <b-card
              border-variant="secondary"
              bg-variant="transparent"
              class="shadow-none"
            >
              <b-overlay
                :show="busy"
                rounded="lg"
                opacity="0.6"
              >
                <b-form-group
                  :label="$t('DEBTIA_APPLY_TERMSHEET_TO')"
                  label-for="process-conditions"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Title"
                    rules="required"
                  >
                    <v-select
                      v-model="applyTermsheetTo"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="applyTermsheetToOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="apply-termsheet-to"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  :label="$t('DEBTIA_TERMSHEET')"
                  label-for="custom-var-options"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('DEBTIA_TERMSHEET')"
                    rules="required"
                  >
                    <v-select
                      v-model="termsheet"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="termsheetOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="termsheet"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-overlay>
            </b-card>
          </b-col>
          <b-col
            v-if="termsheet && applyTermsheetTo"
            cols="12"
          >
            <b-button
              variant="primary"
              type="submit"
              class="addAwaitBtn"
              @click.prevent="validationTermsheetForm"
            >
              {{ $t('DEBTIA_SUBMIT') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormGroup,
  // BFormInput,
  BButton,
  BForm,
  BRow,
  BCol,
  BCard,
  BOverlay,
  // BInputGroup,
} from 'bootstrap-vue'
import axios from '@axios'
import { required, integer } from '@validations'

export default {
  components: {
    // BCardCode,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BCard,
    BOverlay,
    // BInputGroup,
    // BFormInput,
    BButton,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  props: {
    conditionObject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      busy: false,
      required,
      integer,
      applyTermsheetTo: '',
      termsheet: '',
      applyTermsheetToOptions: [
        { value: 'client', label: 'Creditors' },
        { value: 'case', label: 'Cases' },
      ],
      termsheetOptions: [],
    }
  },
  created() {
    this.getTermsheets()
  },
  methods: {
    getTermsheets() {
      this.busy = true
      const url = '/settings/termsheetcode-dropdown'
      axios.get(url).then(response => {
        if (response.status === 200) {
          this.termsheetOptions = response.data.data
          this.busy = false
        }
      })
    },
    validationTermsheetForm() {
      const processID = this.$route.params.id
      const dataObj = {
        process_id: Number(processID),
        module_id: 16,
        module_order: 1,
        termsheet_for: this.applyTermsheetTo,
        termsheet: this.termsheet,
      }
      if (this.conditionObject.moduleID > 0) {
        dataObj.depends_on = this.conditionObject.moduleID
        dataObj.condition = this.conditionObject.type
      }
      this.$refs.termsheetRules.validate().then(success => {
        if (success) {
          const url = '/process/module/add'
          axios.post(url, dataObj).then(response => {
            if (response.status === 200) {
              this.applyTermsheetTo = ''
              this.termsheet = ''
              const returnObj = {
                parentID: this.conditionObject.parentID,
                depend: dataObj.depends_on,
              }
              returnObj.type = this.conditionObject.type ? this.conditionObject.type : 0
              this.$emit('closeTermsheetModal', returnObj)
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .addAwaitBtn {
    width: 100%;
  }
</style>
